import { Flex, Switch, Typography } from 'antd';
import { useEffect, useState } from 'react';
import PlanSelectionItem from '../plan-selection-item/planSelectionItem';
import styles from './PlanSelection.module.css';

const { Title } = Typography;

export default function PlanSelection(props) {
   const { plans, onChange } = props;
   const [billingType, setBillingType] = useState(props.selectedPlan?.billingType || 'yearly');
   const [filteredPlans, setFilteredPlans] = useState(filterPlans());
   const [selectedPlan, setSelectedPlan] = useState(props.selectedPlan || filteredPlans[0]);

   function filterPlans() {
      let filteredPlans = plans.filter((plan) => plan.billingType == billingType);
      filteredPlans.sort((a, b) => a.price - b.price);
      return filteredPlans;
   }

   function handleBillingTypeChange() {
      setBillingType(billingType === 'monthly' ? 'yearly' : 'monthly');
   }

   useEffect(() => {
      setFilteredPlans(filterPlans());
   }, [billingType]);

   useEffect(() => {
      const filteredPlans = filterPlans();
      const plan = filteredPlans.find((plan) => plan.name == selectedPlan?.name);
      setSelectedPlan(plan);
   }, [filteredPlans]);

   useEffect(() => {
      onChange(selectedPlan);
   }, [selectedPlan]);

   return (
      <Flex vertical className={styles.mainContainer} gap={32}>
         <Title level={5}>Choose the plan that suits you best</Title>
         <div className={styles.billingTypeContainer}>
            <p className={styles.billingTypeLabel}>Pay Monthly</p>
            <Switch onChange={handleBillingTypeChange} checked={billingType == 'yearly'} />
            <p className={styles.billingTypeLabel}>Pay yearly</p>
         </div>

         {filteredPlans.map((plan) => (
            <PlanSelectionItem
               plan={plan}
               checked={selectedPlan?._id == plan._id}
               key={plan._id}
               onClick={() => setSelectedPlan(plan)}
            />
         ))}
      </Flex>
   );
}
